import { type Ref, computed } from 'vue';
import { useAsyncData } from 'nuxt/app';
import { useProductStore } from '~~/common/stores/product';

interface Product {
  id?: number;
  reviewable?: string;
  reviewSum?: { sumCount?: number };
  selectedVariant?: { id?: number };
}

export function useProductReviews (productData: Ref<Product>) {
  const productStore = useProductStore();
  const variant = computed(() => productData.value?.selectedVariant);
  const key = computed(() => `awproductreviewformversion2_${productData.value?.id}_${variant.value?.id}`);

  async function fetchReviews () {
    const product = productData.value;
    const variantId = variant.value?.id;
    if (product.id !== undefined && variantId !== undefined && product.reviewable !== 'disabled' && (product.reviewSum?.sumCount ?? 0) > 0) {
      const response = await productStore.fetchReviews({
        id: product.id,
        variantId,
      });
      return Array.isArray(response) ? response : [];
    }
    return [];
  }

  return useAsyncData(
    key.value,
    fetchReviews,
    { default: () => [] as unknown[] },
  );
}
